import type { DiscoveryFilter } from "../../types/filters/common";
import { OnDemandDecksFilterField } from "../../types/filters/onDemandDeckTemplates";

export const onDemandDecksFilters: DiscoveryFilter[] = [
    {
        label: "Topic",
        field: OnDemandDecksFilterField.TOPIC,
        isAdditional: true,
    },
    {
        label: "Language",
        field: OnDemandDecksFilterField.LANGUAGE,
        isAdditional: true,
    },
];

export const defaultOnDemandDecksFilters = onDemandDecksFilters.filter(
    (filter) =>
        [
            OnDemandDecksFilterField.TOPIC,
            OnDemandDecksFilterField.LANGUAGE,
        ].includes(filter.field as OnDemandDecksFilterField),
);
